
import React, { useState } from 'react';
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card';
import { JobSearchResult } from '@/types/jobSearch';
import { cn } from '@/lib/utils';
import { JobDetailsDialog } from './JobDetailsDialog';
import { JobCardHeader } from './JobCardHeader';
import { JobCardContentDetails } from './JobCardContentDetails';
import { JobCardFooterActions } from './JobCardFooterActions';
import { JobSearchResultMatchingCandidatesPreview } from './JobSearchResultMatchingCandidatesPreview'; // Added import
import { toast } from 'sonner'; 

interface JobSearchResultItemProps {
  job: JobSearchResult;
  isSaved: boolean;
  onSaveJob: () => Promise<void>;
  onUnsaveJob: () => Promise<void>;
  isSavingThisJob: boolean;
  isUserLoggedIn: boolean;
  onMakeLead: (job: JobSearchResult) => void;
}

export const JobSearchResultItem: React.FC<JobSearchResultItemProps> = ({
  job,
  isSaved,
  onSaveJob,
  onUnsaveJob,
  isSavingThisJob,
  isUserLoggedIn,
  onMakeLead,
}) => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const handleSaveToggle = async () => {
    if (isSaved) {
      await onUnsaveJob();
    } else {
      await onSaveJob();
    }
  };

  // Robust URL determination
  const determinedJobUrl = job.job_url || job.url || job.raw_data?.job_url || job.raw_data?.url || job.raw_data?.link;
  
  console.log(`JobSearchResultItem (ID: ${job.id}, Title: "${job.title}"):
    job.job_url: ${job.job_url}
    job.url: ${job.url}
    job.raw_data?.job_url: ${job.raw_data?.job_url}
    job.raw_data?.url: ${job.raw_data?.url}
    job.raw_data?.link: ${job.raw_data?.link}
    determinedJobUrl: ${determinedJobUrl}
    job.source: ${job.source}`);

  return (
    <>
      <Card className={cn(
        "transition-all hover:shadow-lg mb-4 border-border",
        isSaved && "border-primary/50 ring-1 ring-primary/50"
      )}>
        <CardHeader className="pb-3">
          <JobCardHeader
            title={job.title || job.job_title || "Untitled Job"}
            companyName={job.company_name}
            jobUrl={determinedJobUrl} // Pass the determined URL
            isUserLoggedIn={isUserLoggedIn}
            isSaved={isSaved}
            isSavingThisJob={isSavingThisJob}
            score={job.score}
            onSaveToggle={handleSaveToggle}
            onViewDetails={() => setIsDetailsModalOpen(true)}
          />
        </CardHeader>
        <CardContent className="space-y-3 text-sm pt-0 pb-4">
          {/* JobCardContentDetails will now receive the full job object, including source */}
          <JobCardContentDetails job={job} />
          {/* Conditionally render matching candidates preview if user is logged in */}
          {isUserLoggedIn && <JobSearchResultMatchingCandidatesPreview searchResultJob={job} />}
        </CardContent>
        <CardFooter className="pt-0">
          <JobCardFooterActions
            job={job}
            isUserLoggedIn={isUserLoggedIn}
            isProcessingAction={isSavingThisJob}
            onViewDetails={() => setIsDetailsModalOpen(true)}
            onMakeLead={onMakeLead}
          />
        </CardFooter>
      </Card>
      <JobDetailsDialog
        job={job} // Pass full job object
        isOpen={isDetailsModalOpen}
        onOpenChange={setIsDetailsModalOpen}
        isJobSaved={isSaved}
        onSaveJob={handleSaveToggle}
        isSavingJob={isSavingThisJob}
        isUserLoggedIn={isUserLoggedIn}
      />
    </>
  );
};

